'use client';

import { IconButton } from '@/components/shared/atoms';
import { authStorage } from '@/lib/storage';
import { usePathname, useRouter } from 'next/navigation';
import Image from 'next/image';
import { BASE_IMAGE_URL } from '@/constants/path';
import { useEffect } from 'react';
import { queryClient } from '@/lib/query';
import { UserRole } from '@/lib/types/account';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { reportFrontendError } from '@/lib/frontend-error-reporter';

interface HeaderUserMenuProps {
  isDark?: boolean;
  userRole: UserRole;
}

const HeaderUserMenu = ({ isDark, userRole }: HeaderUserMenuProps) => {
  const t = useTranslations('common.actions');
  const router = useRouter();
  const pathName = usePathname();
  const MyPageLink = userRole === 'L' ? '/lawyer' : '/my-contract/dashboard';

  const signOut = () => {
    authStorage.sessionClear();
    router.refresh();
    queryClient.clear();

    if (pathName.includes('apply-step') || pathName.includes('my-contract') || pathName.includes('lawyer')) {
      setTimeout(() => {
        router.replace('/');
      }, 100);
    }
  };

  useEffect(() => {
    const currentPage = window.location.pathname;
    const previousPage = sessionStorage.getItem('previousPage');
    if (currentPage !== previousPage) {
      Promise.resolve()
        .then(() => {
          sessionStorage.setItem('previousPage', currentPage);
        })
        .catch(error => {
          // sessionStorage.setItem 은 저장 공간이 차면 QuotaExceededError 를, 저장소 접근이
          // 차단된 컨텍스트에서는 SecurityError 를 던진다. 잡지 않으면 "이전 페이지 기억" 이라는
          // 부가 기능의 실패가 맥락 없는 unhandledrejection 으로 수집된다.
          reportFrontendError(error, { source: 'handled' });
        });
    }
  }, []);

  return (
    <div className="flex items-center gap-2">
      <Image src={`${BASE_IMAGE_URL}/icons/login-user.png`} alt="logo" width={32} height={32} />
      <Link href={MyPageLink} className={`text-body2SemiBold ${isDark ? 'text-white' : 'text-coolNeutral-22'}`}>
        {t('myPage')}
      </Link>
      <IconButton icon="ri-logout-box-r-line" color={isDark ? 'text-white' : 'text-lawkitGray-400'} className="ml-5" size="text-[24px]" onClick={signOut} />
    </div>
  );
};

export default HeaderUserMenu;
